import OpenableTitle from './OpenableTitle';
import { BottomDataWrapper, GroupItemDataWrapper, VerticalDivider } from './styles';
import ContentTypeTag from '../../components/AddContent/ContentTypeTag';
import { CourseLearningArea } from '../styles';
import { Space } from 'antd';
import { durationFromSecs } from 'utils/helpers';
import { pluralize } from 'utils/string';
import { isMobile } from 'react-device-detect';

interface ICollectionItemData {
  data: any;
  onOpen?(): void;
  locked?: boolean;
  toggleDetails?(): void;
}

export const COLLECTION_UNAVAILABLE_LABEL = 'This collection is no longer available';
export const COLLECTION_UNRESOLVED_NAME = 'Unavailable collection';

export const getCollectionLabsSummary = (totalLabs = 0, totalFlags = 0): string => {
  const labs = pluralize(totalLabs, 'lab');
  return totalFlags > 0 ? `${labs} (${pluralize(totalFlags, 'flag')})` : labs;
};

// A reference can outlive the collection it points at: unpublished, archived or
// hard-deleted. Those still render, so the item is never invisible or removable-only.
export const isCollectionUnavailable = (data: { name?: string; status?: string }): boolean =>
  !data?.name || (Boolean(data?.status) && data.status !== 'published');

const CollectionItemData = ({
  data,
  locked,
  toggleDetails,
  onOpen,
}: ICollectionItemData): JSX.Element => {
  const {
    content_type,
    name,
    duration_in_seconds,
    main_learning_area,
    learning_areas,
    total_labs,
    total_flags,
  } = data;

  const unavailable = isCollectionUnavailable(data);
  const dimmed = unavailable || locked;
  const learningAreaName = main_learning_area || learning_areas?.[0]?.name || learning_areas?.[0];

  const handleMobileToogle = () => {
    isMobile && toggleDetails?.();
  };

  return (
    <GroupItemDataWrapper
      onClick={handleMobileToogle}
      style={dimmed ? { opacity: 0.6 } : undefined}
    >
      <Space>
        <ContentTypeTag value={content_type} is_trackable={total_flags > 0} />
      </Space>
      <OpenableTitle onOpen={unavailable ? undefined : onOpen}>
        {name || COLLECTION_UNRESOLVED_NAME}
      </OpenableTitle>
      <BottomDataWrapper>
        {unavailable ? (
          COLLECTION_UNAVAILABLE_LABEL
        ) : (
          <>
            {learningAreaName && (
              <>
                <CourseLearningArea value={learningAreaName}>{learningAreaName}</CourseLearningArea>
                <VerticalDivider />
              </>
            )}
            {getCollectionLabsSummary(total_labs, total_flags)}
            {duration_in_seconds ? (
              <>
                <VerticalDivider />
                {durationFromSecs(duration_in_seconds)}
              </>
            ) : null}
          </>
        )}
      </BottomDataWrapper>
    </GroupItemDataWrapper>
  );
};

export default CollectionItemData;
